// removed by extract-text-webpack-plugin
module.exports = {"small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","container":"container-2Lyan","title":"title-15jiR","body":"body-19BAS","side":"side-3cL09","cardFace":"cardFace-2m0h0","subtitle":"subtitle-2MRRc","cards":"cards-31YZ9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/CCForm/_cvcTooltip.css
// module id = 1240
// module chunks = 1